import React from 'react'
import { Chart } from 'primereact/chart';

const Monthwise = (props) => {

    const monthwiseData = props?.monthwiseData || [];

    const groupedData = monthwiseData.reduce((acc, item) => {
        const { createDate, status, totalCount } = item;
        if (!acc[createDate]) {
            acc[createDate] = { "SUCCESSFUL": 0, "VALIDATION SUCCESSFUL": 0, "PENDING": 0, "FAILED": 0 };
        }
        acc[createDate][status] += totalCount;
        return acc;
    }, {});

    const uniqueDates = Object.keys(groupedData);

    const successfulData = uniqueDates.map(date => groupedData[date]["SUCCESSFUL"]);
    const validationSuccessfulData = uniqueDates.map(date => groupedData[date]["VALIDATION SUCCESSFUL"]);
    const checkerApprovedData = uniqueDates.map(date => groupedData[date]["PENDING"]);
    const failedData = uniqueDates.map(date => groupedData[date]["FAILED"]);

    const monthWiseData = {
        labels: uniqueDates || [],
        datasets: [
            {
                label: 'Validation Successful',
                backgroundColor: '#82e0aa',
                data: validationSuccessfulData,
                hoverBackgroundColor: '#82e0aa'
            },
            {
                label: 'Approved',
                backgroundColor: '#f5b041',
                data: checkerApprovedData,
                hoverBackgroundColor: '#f5b041'
            },
            {
                label: 'Failed',
                backgroundColor: '#e74c3c',
                data: failedData,
                hoverBackgroundColor: '#ec7063'
            },
            {
                label: 'Successful',
                backgroundColor: '#52be80',
                data: successfulData,
                hoverBackgroundColor: '#52be80'
            },
        ]
    };

    const getLightTheme = () => {

        let horizontalOptions = {
            indexAxis: 'y',
            maintainAspectRatio: false,
            aspectRatio: .8,
            // plugins: {
            //     legend: {
            //         labels: {
            //             color: '#495057'
            //         }
            //     }
            // },
            title: {
                display: true,
                text: 'Disbursement Details',
                fontSize: 14
            },
            legend: {
                labels: {
                    fontColor: '#495057',
                    fontSize: 10,
                    boxWidth: 10
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return {
            horizontalOptions
        }
    }

    const { horizontalOptions } = getLightTheme();

    const isDataAvailable =
        props?.monthwiseData &&
        Array.isArray(props?.monthwiseData) &&
        props.monthwiseData.length > 0;

    return (
        <>

            <div className="p-col-4">
                <div className="card graph_card position_relative">
                    {/* <h5>Disbursement Details</h5> */}
                    {
                        isDataAvailable ?
                            <Chart type="horizontalBar" data={monthWiseData} options={horizontalOptions} height="290px" />

                            :
                            <div className='no_records'>
                                No Records Found
                            </div>
                    }
                </div>
            </div>

        </>
    )
}

export default Monthwise